// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mKIxM","input":"styles_input__1gloz"};